export const environment = {
  
  production: false,

  API_URL: 'https://uatepcintegrationapi.unisourcejv.com/api',
  ORIGIN_PATH: 'epc/origins/' ,//'epc/origins/dev/',
  FEES_PATH: 'integrations/title/fees/',
  DOCUMENTS_PATH: 'integrations/documents/',
  EPC_DOCUMENTS_PATH: 'epc/documents/',
  UPLOADDOCUMENTS_PATH: 'epc/documents',
  UPLOADTORESWARE_PATH: 'integrations/documents',
  ORDERS_PATH: 'integrations/title/Order/',
  TRANSACTION_STATUS_PATH: 'epc/status/',
  STATUS_PATH: 'integrations/title/order/Status/',
  FEES_STATUS_PATH: 'integrations/title/fees/Status/',
  DOCUMENTS_STATUS_PATH: 'integrations/documents/',
  DOCUMENTS_DOWNLOAD_STATUS_PATH: 'epc/documents/status/', 
  ORDER_HISTORY_PATH: 'integrations/title/order/history/',
  FEES_HISTORY_PATH: 'integrations/title/fees/history/',
  INTEGRATIONS_LOG_PATH: 'integrations/log',
  PRODUCTS_PATH: 'integrations/products',

  PROVIDER_PATH: 'provider/EncompassPartnerConnect/Retrieve/',
  PRODUCT_PATH: 'product/EncompassPartnerConnect/Retrieve/',
  AUDITLOG_PATH: 'AuditLog/EncompassPartnerConnect/Retrieve/',

  REQUEST_TYPE: 'Lenders One SMARTOrder',
  REQUEST_TYPE_ADMIN: 'Lenders One SMARTOrder Automated'
};
